<template>
		<el-dialog title="绑定客户名称" :visible.sync="visible" :before-close="beforeClose" width="70%">
				<el-form :model="form" inline style="margin-top: 30px;">
					<el-row>
						<el-form-item label="通话编号">
								<div>{{form.CallSheetId}}</div>
						</el-form-item>
					</el-row>
				
					<el-row>
						<el-form-item label="客户名称">
								<el-input v-model="form.companyName" type="text" autocomplete="off"
													class="text-width"></el-input>
						</el-form-item> 
					</el-row>                       
				</el-form>

				<div slot="footer" class="dialog-footer">
						<el-button @click="beforeClose">取消</el-button>
						<el-button type="primary" @click="onConfirm">保存</el-button>
				</div>
		</el-dialog>

</template>

<script>
import {SetCompanyName} from "@/api/bd";
import {getToken} from "@/utils/auth";
import {mapGetters} from "vuex";

export default {
		name: "EditAccountDialog",
		components: {},
		// computed: {
		// 		...mapGetters(['mediumList', 'mediaList',])
		// },
		props: ['visible','dateArray','searchkey', 'currentItem'],
		watch: {
				async visible(newValue) {
						if (newValue) {
								if (this.currentItem?.CallSheetId) {
										this.form = this.currentItem;
								}
						}
				}
		},
		data() {
				return {
						// isMyCompanyOptions: [{label: '自有媒体', value: 1}, {label: '竞争媒体', value: 0},],
						// form: {accountName: '', account: '', bank: '',}
						form:{},
				};
		},
		methods: {
				async onConfirm() {
						const {CallSheetId, companyName} = this.form;
						const [sDate, eDate] = this.dateArray;
						// console.log('this.searchkey')
						// console.log('this.searchkey',this.searchkey)
                        await SetCompanyName({userId: getToken(), CallSheetId, companyName});
						// this.form = {accountName:'', account : '', bank:'',};
						this.beforeClose();
						 await this.$store.dispatch("bd/callLogList", {
                            sDate,
                            eDate,
                            key:this.searchkey
                        })
				},
				beforeClose() {
						this.$emit('update:visible', false);
				}
		}
}
</script>

<style scoped>

</style>